import { useTranslation } from 'react-i18next';

export const NoRowsOverlay = () => {
  const { t } = useTranslation();

  return <div className="flex h-full w-full items-center justify-center text-gray-500">{t('common.noData')}</div>;
};
